import UserAppContext from '../../hook/UserAppContext'
import Banner from '../banner/Banner'
import Container from '../container/Container'

import './content.css'

const Content = () => {

      const {user} = UserAppContext()

      if(user.length === 0) return 

      return (
            <div className="content">
                  <Banner />
                  <Container />
            </div>
      )
}

export default Content
